module.exports = __webpack_public_path__ + "img/public/AdminIcons/manageUser.svg?40996bc1";